export { Slate as RichTextCore, type RichTextTypography } from '@makeswift/controls'
export { type RichTextV2Plugin } from '../../controls/rich-text-v2/plugin'
